<template>
    <div class="modal" :class="{'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">MultiProforma Invoice #{{ number }}</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
               <multi-proforma-invoice-body></multi-proforma-invoice-body>
            </section>
            <footer class="modal-card-foot">
                <button class="button"  @click="closeModal">Close</button>
                <button class="button is-primary" @click="saveProformaInvoice">Save</button>
                <button class="button is-danger" v-if="isAdmin" :disabled="isLocked" @click="openProformaDeleteModal">DELETE</button>
            </footer>
        </div>
        <deleete-multi-proforma-modal v-if="isAdmin" :invoiceId="invoiceId"></deleete-multi-proforma-modal>
    </div>
</template>

<script>

    import MultiProformaInvoiceBody from "./MultiProformaInvoiceBody";
    import DeleeteMultiProformaModal from "./DeleeteMultiProformaModal";
    export default {
        props:['car', 'invoice'],
        components: {
            DeleeteMultiProformaModal,
            MultiProformaInvoiceBody,

        },
        methods: {
            closeModal() {
                this.$store.dispatch('updateMultiProformaModal', false)
            },
            goToUserPage(id){
                this.$router.push({ name: 'EditUser', params: { id: id } });
            },
            downloadPDF() {
                this.$store.dispatch('downloadProformaInvoicePdf')
            },
            downloadEXCEL() {
                this.$store.dispatch('downloadProformaInvoiceExcel')
            },
            saveProformaInvoice() {
                const multiProforma = this.$store.getters.getMultiProformaFields;
                this.$store.dispatch('saveMultiProformaInvoice', multiProforma)
                //this.$store.dispatch('fetchProformaInvoice', this.car.id)
                //this.setCurrentCarProformaInvoice()
            },
            createProforma() {
                this.$store.dispatch('createProformaInvoice')
                    .then(this.car.proforma_invoice = this.$store.getters.getProformaInvoice)
            },
            setCurrentCarProformaInvoice() {
                if (this.$store.getters.getProformaInvoice.id !== null) {
                    this.car.proforma_invoice = this.$store.getters.getProformaInvoice
                }
            },
            lockProformaInvoice() {
                let value = this.isLocked ? null : 1
                this.$store.dispatch('changeProformaInvoiceFieldValue', {field: 'locked', value: value})
                this.saveProformaInvoice()
            },
            openProformaDeleteModal(){
                this.$store.dispatch('setMultiProformaDeleteModalStatus', true)
            }
        },
        computed: {
            number(){
                return this.$store.getters.getMultiProformaFields.invoice_number
            },
            invoiceId(){
                return this.$store.getters.getMultiProformaFields.id
            },
            hasNoInvoice () {
                return this.car.proforma_invoice === null
            },
            isActive() {
                return this.$store.getters.getUpdateMultiProformaModal
            },
            haveNoPricePlan() {
                return this.car.user.price_plan === null
            },
            haveNoPortOfLoading() {
                return this.car.port_of_loading === null
            },
            buttonsEnabled() {
                return !this.$store.getters.getProformaInvoiceErrorStatus
            },
            invoiceUpdateDate() {
                return this.$store.getters.getProformaInvoice.updated_at
            },
            errorStatus() {
                return this.$store.getters.getProformaInvoiceErrorStatus
            },
            errorMessage() {
                return this.$store.getters.getProformaInvoiceErrorMessage
            },
            isAdmin() {
                return this.$store.getters.checkIfUserIsAdmin
            },
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 90%;
    }
    .text-button {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    td {
        font-size: large;
    }
    .is-static {
        min-width: 50px;
    }
    th {
        font-size: small;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/MultiProformaModal/MultiProformaInvoiceModal.vue